import RolesFormContainer from 'components/Forms/Role/RolesFormContainer'
import React from 'react'

const RegisterUsers = () => {
  return (
    <RolesFormContainer />
  )
}

export default RegisterUsers
